import { injectable } from 'inversify';
import { NavigateFunction } from 'react-router-dom';
import {
  ConneqtRepository,
  PlayerRepository,
} from '../../../state/reduxRepositories';
import {
  ConneqtStatus,
  ViewConneqtPayload,
} from '../../../state/reduxRepositories/conneqt/conneqt.interfaces';
import { ConneqtSubRoutes } from '../conneqtSubRoutes';
import { AddNewPlayerView } from './addNewPlayer.view.service';
import { NewPlayerInputs } from '../../players/addPlayer.domain';
import { PlayerCreatePayload } from '../../../state/reduxRepositories/players/player.interfaces';
import { getPlayerDetails } from '../conneqt.helper';

// This is used when selecting player for a conneqt request and user choose to conneqt a 'new player' from the select box. Currently only guardians can respond to conneqt requests.
@injectable()
export class ConneqtNewPlayerDomain {
  constructor(
    private addNewPlayerView: AddNewPlayerView,
    private conneqtRepository: ConneqtRepository,
    private playerRepository: PlayerRepository,
  ) {}

  usePendingPlayerCreationConneqtId = () => {
    return this.addNewPlayerView.usePendingPlayerCreationConneqtId();
  };

  usePendingPlayerCreationCluesAsInputs = () => {
    const clues = this.addNewPlayerView.usePendingPlayerCreationClues();
    const playerDetails = getPlayerDetails(clues);

    if (playerDetails) {
      const nameParts = playerDetails.name.split(' ');
      const dateParts = playerDetails.dob.split('/');
      const inputs: NewPlayerInputs = {
        lastName: nameParts.length > 1 ? nameParts.slice(1).join(' ') : '',
        firstName: nameParts[0],
        dateOfBirth: playerDetails.dob,
      };

      return inputs;
    }
    return {};
  };

  dispatchCreatePlayer = (
    newPlayer: PlayerCreatePayload,
    navigator: NavigateFunction,
  ) => {
    this.playerRepository
      .dispatchCreateAsync(newPlayer)
      .then((playerId) => {
        this.dispatchConneqtPlayer(playerId, navigator);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  private dispatchConneqtPlayer = (
    newPlayerId: string,
    navigator: NavigateFunction,
  ) => {
    const { pendingConneqtId } = this.addNewPlayerView.viewStateSelector();

    if (!pendingConneqtId || !newPlayerId) {
      return;
    }

    this.conneqtRepository.dispatchUpdate({
      id: pendingConneqtId,
      responsePlayerId: newPlayerId,
      status: ConneqtStatus.Conneqted,
      // QUESTION: why is disconnectedAccountId set?
      // disconnectedAccountId: accountId,
    });

    this.dispatchNoLongerPending();

    navigator(`../${ConneqtSubRoutes.all}`);
  };

  dispatchPlayerCreationPending = (pendingConneqt: ViewConneqtPayload) => {
    this.addNewPlayerView.dispatchViewState({
      pendingConneqtId: pendingConneqt.id,
      playerClues: pendingConneqt.requestPlayerClues,
      // sourceEmail: pendingConneqt.re
    });
  };

  dispatchNoLongerPending = () => {
    this.addNewPlayerView.dispatchClearView();
  };
}
